export default __webpack_public_path__ + "static/media/alterarSenha.af7cc259.png";